import { render, staticRenderFns } from "./recording-sharing.component.vue?vue&type=template&id=71952266&scoped=true&"
import script from "./recording-sharing.component.vue?vue&type=script&lang=js&"
export * from "./recording-sharing.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71952266",
  null
  
)

export default component.exports